import React from 'react';
import styled from '@emotion/styled';

import { Blockquote } from './Blockquote';
import { QuoteImagesBlock } from './QuoteImagesBlock';
import { SCREEN_BREAKPOINTS } from '../../constants';

const QuoteSection = styled.section`
  padding: 140px 0;

  @media (max-width: ${SCREEN_BREAKPOINTS.SMALL_DESKTOP}px) {
    padding: 100px 0;
  }
`;

export const Quote = () => {
  return (
    <QuoteSection>
      <Blockquote />
      <QuoteImagesBlock />
    </QuoteSection>
  );
};
